import { render, staticRenderFns } from "./CreateConcerns.vue?vue&type=template&id=5502c0b8&scoped=true&"
import script from "./CreateConcerns.vue?vue&type=script&lang=js&"
export * from "./CreateConcerns.vue?vue&type=script&lang=js&"
import style0 from "./CreateConcerns.vue?vue&type=style&index=0&id=5502c0b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5502c0b8",
  null
  
)

export default component.exports